import { getFunctions, httpsCallable } from "firebase/functions";

export const generateGameExportPdf = async (gameId) => {
  const functions = getFunctions();
  const generateGamePdf = httpsCallable(functions, "generateGamePdf");
  const res = await generateGamePdf({ id: gameId });
  return res?.data?.url;
};
